import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { cloneElement } from "react";
/**
 * Draggable row is used for antd Table.
 * @see https://app.clickup.com/t/861m6y395
 * @see https://codesandbox.io/s/sortable-antd-table-with-dnd-kit-forked-mhuv6u?file=/demo.js:2805-2817 found demo
 *
 * Example usage you can find in purpose-table.tsx
 */ function DraggableRow({ children, className, style: styleFromProps, ...remainingProps }) {
    const rowKey = String(remainingProps["data-row-key"]);
    if (Array.isArray(children)) {
        const { setNodeRef, attributes, listeners, transition, transform } = useSortable({
            id: rowKey
        });
        const style = {
            ...styleFromProps,
            transition,
            transform: CSS.Transform.toString(transform)
        };
        // create copy of children, don't mutate original children list !
        const copyOfChildren = [
            ...children
        ];
        /**
         * MaGü: Please note, that you need to define at least one column of your table columns
         * to be "dataIndex": "sort"
         *
         * Example Column:
         * ```
         * {
         *      title: t("Sort"),
         *      dataIndex: "sort",
         *      width: 30,
         *      render: () => <MenuOutlined style={{ cursor: "grab", color: "#999" }} />
         *  },
         * ```
         */ const indexOfSortHandle = copyOfChildren.findIndex((child)=>// React key
            child.key === "sort" || // Compatibilty with antd design table
            child.props?.dataIndex === "sort");
        // clone sort handle element and add listeners and attributes
        const sortTriggererHandleCell = /*#__PURE__*/ cloneElement(copyOfChildren[indexOfSortHandle], {
            additionalProps: {
                ...attributes,
                ...listeners
            }
        });
        // replace old element with new clone
        copyOfChildren.splice(indexOfSortHandle, 1, sortTriggererHandleCell);
        return /*#__PURE__*/ _jsx("tr", {
            ref: setNodeRef,
            className: className,
            ...remainingProps,
            style: style,
            children: copyOfChildren
        }, rowKey);
    } else {
        // Return default children if no data array is rendered
        return /*#__PURE__*/ _jsx("tr", {
            className: className,
            ...remainingProps,
            style: styleFromProps,
            children: children
        }, rowKey);
    }
}
export { DraggableRow };
